<template>
  <div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <label>{{campaign.name}}</label>
          <label class="label">Статистика задач</label>
          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
              <tr>
                <th>Состояние</th>
                <th>Количество</th>
              </tr>
              </thead>
              <tbody>
                <tr>
                  <td>В очереди</td>
                  <td>{{campaignProgress.ready}}</td>
                </tr>
                <tr>
                  <td>Вызов</td>
                  <td>{{campaignProgress.dialing}}</td>
                </tr>
                <tr>
                  <td>Идет разговор</td>
                  <td>{{campaignProgress.ongoing}}</td>
                </tr>
                <tr>
                  <td>Выполнена</td>
                  <td>{{campaignProgress.performed}}</td>
                </tr>
                <tr>
                  <td>Недозвон</td>
                  <td>{{campaignProgress.failed}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <label class="label">Метрики прозвона</label>
          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
              <tr>
                <th>Метрика</th>
                <th>Значение</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Скорость выполнения</td>
                <td>{{campaignProgress.performingSpeed}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <p class="control">
            <button class="button is-light" v-on:click="cancel">
              <span class="icon">
                <i class="fa fa-times-circle"></i>
              </span>
              <span>Закрыть</span>
            </button>
          </p>
        </article>
      </div>
    </div>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex'
  import Vue from 'vue'
  import CheckToken from '../authentication/CheckToken'

  Vue.mixin(CheckToken)

  const MONITORING_API = '/monitoring'
  const CAMPAIGNS_API = '/api/campaigns'

  export default {
    props: ['id'],
    data () {
      return {
        campaignProgress: {},
        campaign: ''
      }
    },
    created () {
      this.checkToken()
      this.calltasks = this.loadData()
      this.loadCampaign()
      this.monitoringCampaign()
    },
    computed: {
      ...mapGetters([
        'authenticationToken',
        'loggedId'
      ])
    },
    methods: {
      prepareSecurityHeader() {
        console.log(this.authenticationToken)
        return {
          Authorization: `Bearer ${this.authenticationToken}`
        }
      },
      loadData () {
        this.$http.get(MONITORING_API + '/' + this.$props.id, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.campaignProgress = response.data
          })
          .catch((error) => {
            console.log(error)
          })
      },
      monitoringCampaign () {
        this.$root.monitor = setInterval(() => {
          this.calltasks = this.loadData()
        }, 60000)
      },
      loadCampaign () {
        this.$http.get(CAMPAIGNS_API + '/' + this.$props.id, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.campaign = response.data
          })
      },
      cancel () {
        clearInterval(this.$root.monitor)
        this.$router.push('/campaigns/' + this.$props.id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CampaignMonitoring.vue?ef5cc086